import { useNavigate, useSearch } from '@tanstack/react-router';

import {
  dashboardRouteSearchSchema,
  parseDashboardRouteSearch,
  serializeDashboardRouteFilters,
} from '../../../dashboard/dashboardRouteSearch';
import type { DashboardDateRange } from '@/components/dashboard/model';

export function useNetworkDashboardRouteFilters() {
  const navigate = useNavigate({ from: '/networks/$networkId/details/overview' });
  const search = useSearch({ strict: false });
  const { range } = parseDashboardRouteSearch(dashboardRouteSearchSchema(search));

  return {
    range,
    setRange: (nextRange: DashboardDateRange) => {
      void navigate({
        search: serializeDashboardRouteFilters({ range: nextRange }),
        replace: true,
      });
    },
  };
}
